@import '../../../../theme/colors';

.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.menu {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  border-bottom: 2px solid $lighterGrey;
  margin: 0;
  padding: 0;
  list-style: none;

  a {
    box-sizing: content-box;
    color: $neutral-600;
    position: relative;
    top: 4px;
    padding: 10px;
    border-bottom: 4px solid transparent;
    text-decoration: none;
    font-weight: 400;
    &:not(:last-of-type) {
      margin-right: 20px;
    }
    .menuItem {
      margin: 0;
      padding: 0;
      font-family: var(--font-family__heading);
      font-size: 16px;
      white-space: nowrap;
    }
  }
  .current {
    font-weight: 600;
    border-bottom: 4px solid $oceanBlue;
  }
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  form {
    fieldset:first-child {
      border-top: none;
      margin-top: 0;
      padding-top: 0;
    }
  }
}

.formSectionHeading {
  font-family: var(--font-family__heading);
  color: $neutral-600;
  font-weight: 600;
  font-size: 16px;
  margin: 0;
}

.serviceDeskFieldsSection {
  margin-top: 16px;
}
